import { render, staticRenderFns } from "./PivotTable.vue?vue&type=template&id=2c1e049b&scoped=true"
import script from "./PivotTable.vue?vue&type=script&lang=js"
export * from "./PivotTable.vue?vue&type=script&lang=js"
import style0 from "./PivotTable.vue?vue&type=style&index=0&id=2c1e049b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1e049b",
  null
  
)

export default component.exports